export default __webpack_public_path__ + "static/media/bg.017b6b2a.png";